import { getPermissions } from '@/api/Sys'
import routes from '@/router/routerConfig.js'
export default {
  namespaced: true,
  state: {
    trueRoutes: [],
    routeName: '',
    breadcrumb: [],
    trueRouteNames: [],
    beforeName: '',
    appCodeList: [
      { typeCode: 'GLYHT', typeName: '管理员后台' },
      { typeCode: 'YHGHT', typeName: '用户后台' },
      { typeCode: 'WYPY', typeName: '微信平台' }
    ],
    buttonAuthority: {},
    noBreadCrumb: false

  },
  actions: {
    async getPermissions({ commit }) {
      const res = await getPermissions()
      if (res.code === 200) {
        commit('getTrueRoutes', res.data)
      }
    }
  },
  mutations: {
    getTrueRoutes(state, apiRoutes) {
      state.buttonAuthority = {}
      let arrName = ['Errorpage', 'Login', 'Index', 'Dom2']
      let arr = []
      routes.forEach((item) => {
        apiRoutes.some((items) => {
          if (item.path === items.attributes.menuUrl) {
            let obj = {}
            arrName.push(item.name)
            obj.meta = item.meta
            obj.path = item.path
            obj.fullPath = item.path
            obj.name = item.name
            obj.text = items.text
            obj.children = []
            obj.resourceType = items.attributes.resourceType
            const setRoute = function(apiItem) {
              if (apiItem.children && apiItem.children.length) {
                apiItem.children.forEach((apiIt) => {
                  item.children.forEach((it) => {
                    if (item.path + '/' + it.path === apiIt.attributes.menuUrl) {
                      let ob = {}
                      ob.path = it.path
                      ob.meta = it.meta
                      ob.name = it.name
                      ob.fullPath = apiIt.attributes.menuUrl
                      ob.text = apiIt.text
                      if (apiIt.attributes.menuShow) {
                        obj.children.push(ob)
                      }
                      arrName.push(it.name)
                      return true
                    }
                  })
                  if (apiIt.children && apiIt.children.length) {
                    let obj = {}
                    obj[apiIt.attributes.menuUrl] = []
                    apiIt.children.forEach((code) => {
                      obj[apiIt.attributes.menuUrl].push(code.code)
                    })
                    state.buttonAuthority = Object.assign(state.buttonAuthority, obj)
                    setRoute(apiIt)
                  }
                })
              }
            }
            setRoute(items)
            if (items.attributes.menuShow) {
              arr.push(obj)
            }
            return true
          }

        })
      })
      state.trueRoutes = arr
      state.trueRouteNames = arrName

    },
    setBreadcrumb(state, to) {
      if (!to.matched.length) {
        return
      }
      const obj1 = {
        path: to.matched[0].path,
        text: to.matched[0].meta.title,
        name: to.name
      }
      const obj2 = {
        path: to.fullPath,
        text: to.meta.title,
        name: to.name
      }
      let breadcrumb = []
      breadcrumb.push(obj1)
      
      if (to.meta && to.meta.activePath) {
        const obj3 = {
          path: to.meta.activePath,
          text: to.meta.activeName,
          name: to.name
        }
        breadcrumb.push(obj3)
      } 
      breadcrumb.push(obj2)
      state.breadcrumb = breadcrumb
    },
    saveNowRoute(state, name) {
      if (name === 'Errorpage' || name === 'Login') return
      state.routeName = name
    },
    saveLoginBeforeName(state, name) {
      if (name === 'Errorpage' || name === 'Login') return
      state.beforeName = name
    },
    saveNoBreadCrumb(state, noBreadCrumb) {
      console.log(noBreadCrumb)
      if (noBreadCrumb) {
        state.noBreadCrumb = true
      } else {
        state.noBreadCrumb = false
      }
    }
  },
  getters: {
    getDefaultRouteName(state) {
      return state.routeName
    },
    getPermission(state) {
      return state.trueRoutes
    },
    getRole: (state) => (path) => {
      if (state.buttonAuthority[path] && state.buttonAuthority[path].length) {
        let obj = {}
        for (let i = 0; i < state.buttonAuthority[path].length; i++) {
          obj[state.buttonAuthority[path][i]] = true
        }
        return obj
      } else {
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/modules/promise.js